import { createApp } from 'vue';
import ShiftApp from './ShiftApp.vue';
import vuetify from './plugins/vuetify';
import { loadFonts } from './plugins/webfontloader';
import router from '@/router';
import store from '@/store';
import i18n from '@/i18n';
import Chart from 'vue-frappe-chart';

loadFonts();

createApp(ShiftApp)
  .use(router)
  .use(store)
  .use(i18n)
  .use(vuetify)
  .use(Chart)
  .mount('#app');
